import React from 'react'
import styled from 'styled-components'
import AppleIcon from '../../../../../../generic/icons/IconLib/AppleIcon'
import ScalesIcon from '../../../../../../generic/icons/IconLib/ScaleIcon'
import PackageIcon from '../../../../../../generic/icons/IconLib/PackageBoxIcon'
import UserIcon from '../../../../../../generic/icons/IconLib/UserIcon'
import ProductImage from '../../../queries/TeudotDetails/Components/ProductImage'
import { ISrikaItem } from '../../../../../../modules/API/Gathering/models/srika'

type Props = {
  palletData: ISrikaItem
}

const PalletProductCard = ({ palletData }: Props) => {
  return (
    <ProductCard>
      <ImageSection>
        <ProductImage 
          id={palletData.GeneralProductID || 0}
          size="lg"
        />
      </ImageSection>
      <InfoSection>
        <InfoRow>
          <InfoValue>{`${palletData.ProductDesc.trim()} ${palletData.VarietyDesc.trim()} ${palletData.SizeDesc.trim()}`}</InfoValue>
          <InfoIcon><AppleIcon /></InfoIcon>
        </InfoRow>

        <InfoRow>
          <InfoValue>{palletData.BalanceWeight?.toFixed(2) || '0'} / {palletData.Gross?.toFixed(2) || '0'}  ק"ג</InfoValue>
          <InfoIcon><ScalesIcon /></InfoIcon>
        </InfoRow>
        <InfoRow>
          <InfoValue>{palletData.BalanceAmount || 0} / {palletData.AmountPack || 0}</InfoValue>
          <InfoIcon><PackageIcon /></InfoIcon>
        </InfoRow>
        {palletData.GrowerName && (
          <InfoRow>
            <InfoValue>{palletData.GrowerName.trim()}</InfoValue>
            <InfoIcon><UserIcon /></InfoIcon>
          </InfoRow>
        )}
      </InfoSection>
    </ProductCard>
  )
}

const ProductCard = styled.div`
  display: flex;
  width: 100%;
  padding: 1em;
`

const ImageSection = styled.div`
  flex-shrink: 0;
  align-self: center;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

const InfoSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.75em;
  min-width: 0;
`

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5em;
  font-size: 0.95em;
`

const InfoValue = styled.span`
  color: #2c3e50;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const InfoIcon = styled.div`
  color: #297F76;
  font-size: 1em;
  flex-shrink: 0;
  display: flex;
  align-items: center;
`

export default PalletProductCard

